module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3QzOZ"))).then(() => parcelRequire('ikE14'));